import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Loader, Tiles, ContainerControlSite, Content } from '@simplybenefits/sb-ui-library';

import Header from '../../components/Header.js';
import permissionLevel from '../../services/permissions.js';

class Dashboard extends PureComponent {
    state = {
        showDropZone: false
    };

    render() {
        const { accessType } = this.props;

        let tiles = [];

        permissionLevel('Members', accessType).includes('read') &&
            tiles.push({
                title: 'Members',
                description: 'View and manage members across all accounts.',
                link: '/members',
                testid: 'members-tile'
            });

        permissionLevel('Advisors', accessType).includes('read') &&
            tiles.push({
                title: 'Advisors',
                description: 'View and manage advisors.',
                link: '/advisors',
                testid: 'advisors-tile'
            });

        permissionLevel('Accounts', accessType).includes('read') &&
            tiles.push({
                title: 'Accounts',
                description: 'View and manage accounts.',
                link: '/accounts',
                testid: 'accounts-tile'
            });

        permissionLevel('Adjudication', accessType).includes('read') &&
            tiles.push({
                title: 'Adjudication',
                description: 'View and adjudicate claims.',
                link: '/adjudication',
                testid: 'adjudication-tile'
            });

        permissionLevel('Quotes for Review', accessType).includes('read') &&
            tiles.push({
                title: 'Quotes for Review',
                description: 'View and manage pending quotes.',
                link: '/quotes-for-review',
                testid: 'quotes-for-review-tile'
            });

        permissionLevel('Reports', accessType).includes('read') &&
            tiles.push({
                title: 'Reports',
                description: 'View and download reports.',
                link: '/reports',
                testid: 'master-reports-tile'
            });

        permissionLevel('Data Uploads', accessType).includes('write') &&
            tiles.push({
                title: 'Data Uploads',
                description: 'Upload Data',
                link: '/uploads',
                testid: 'master-uploads-tile'
            });

        tiles.push({
            title: 'Notifications',
            description: 'View internal system notifications.',
            link: '/notifications',
            testid: 'master-notifications-tile'
        });

        tiles.push({
            title: 'Metrics',
            description: 'Quick view of metrics.',
            link: '/metrics',
            testid: 'master-metrics-tile'
        });

        return (
            <ContainerControlSite background={"true"}>
                <Header
                    subHeader="Dashboard"
                    selectedTitle="dashboard"
                />

                <Content>
                    <Tiles tiles={tiles} />
                </Content>

                <span id="dashboard" />
                {this.props.loader?.isLoading && <Loader isContainer/>}
            </ContainerControlSite>
        );
    }
}

Dashboard.propTypes = {
    notifications: PropTypes.array,
    accessType: PropTypes.string
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    notifications: state.notifications.items,
    accessType: state.master.access,
    email: state.master.email
});

export default connect(mapStateToProps)(Dashboard);